function isNotUndefined(val) {
  return typeof val !== 'undefined';
}

export { isNotUndefined };
